export default __webpack_public_path__ + "static/altaConcurrencia-f5460598d6249117d013d91999f2f7ac.svg";